var Backbone, EmailFormIntlBaseDateInputView, EmailFormIntlDateInputView,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

EmailFormIntlBaseDateInputView = require("./base_date_input_view.coffee");

Backbone = require('backbone');

Backbone.$ = $;

EmailFormIntlDateInputView = (function(superClass) {
  extend(EmailFormIntlDateInputView, superClass);

  function EmailFormIntlDateInputView() {
    return EmailFormIntlDateInputView.__super__.constructor.apply(this, arguments);
  }

  EmailFormIntlDateInputView.prototype.tagName = 'li';

  EmailFormIntlDateInputView.prototype.events = {
    'change .date_input': 'validateEmailForm',
    'keydown .date_input': 'deleteKeyDownHandler'
  };

  EmailFormIntlDateInputView.prototype.initialize = function() {
    EmailFormIntlBaseDateInputView.prototype.initialize.apply(this, arguments);
    this.elementID = ".date_input";
    return this.show_template = {
      date_input_template: true
    };
  };

  EmailFormIntlDateInputView.prototype.readInput = function() {
    return this.getInputHtmlElement().val().trim();
  };

  return EmailFormIntlDateInputView;

})(EmailFormIntlBaseDateInputView);

module.exports = EmailFormIntlDateInputView;

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUvcm11cnVnYW4vbmFwaXN0cmFuby9idWlsZC8xNTAxNzgyMDE2MzA2LTU5NDM1L3Byb2R1Y3Rpb24tMjAxNy4wOC4wM18xNy4zNi9zdXBwb3J0X2FwcC9tb2R1bGVzL3N1cHBvcnQvZnJvbnRlbmQvdmlld3MvZW1haWxfZm9ybS9JTlRML2RhdGVfaW5wdXRfdmlldy5jb2ZmZWUiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIvdmFyL2dyb3Vwb24vaG9tZS9ybXVydWdhbi9uYXBpc3RyYW5vL2J1aWxkLzE1MDE3ODIwMTYzMDYtNTk0MzUvcHJvZHVjdGlvbi0yMDE3LjA4LjAzXzE3LjM2L3N1cHBvcnRfYXBwL21vZHVsZXMvc3VwcG9ydC9mcm9udGVuZC92aWV3cy9lbWFpbF9mb3JtL0lOVEwvZGF0ZV9pbnB1dF92aWV3LmNvZmZlZSJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxJQUFBLG9FQUFBO0VBQUE7OztBQUFBLDhCQUFBLEdBQWlDLE9BQUEsQ0FBUSwrQkFBUjs7QUFDakMsUUFBQSxHQUFXLE9BQUEsQ0FBUSxVQUFSOztBQUNYLFFBQVEsQ0FBQyxDQUFULEdBQWE7O0FBRVA7Ozs7Ozs7dUNBQ0osT0FBQSxHQUFTOzt1Q0FFVCxNQUFBLEdBQ0U7SUFBQSxvQkFBQSxFQUF3QixtQkFBeEI7SUFDQSxxQkFBQSxFQUF3QixzQkFEeEI7Ozt1Q0FHRixVQUFBLEdBQVksU0FBQTtJQUNWLDhCQUE4QixDQUFBLFNBQUUsQ0FBQSxVQUFVLENBQUMsS0FBM0MsQ0FBaUQsSUFBakQsRUFBdUQsU0FBdkQ7SUFDQSxJQUFDLENBQUEsU0FBRCxHQUFhO1dBQ2IsSUFBQyxDQUFBLGFBQUQsR0FBaUI7TUFBQyxtQkFBQSxFQUFxQixJQUF0Qjs7RUFIUDs7dUNBTVosU0FBQSxHQUFXLFNBQUE7V0FDVCxJQUFDLENBQUEsbUJBQUQsQ0FBQSxDQUFzQixDQUFDLEdBQXZCLENBQUEsQ0FBNEIsQ0FBQyxJQUE3QixDQUFBO0VBRFM7Ozs7R0FiNEI7O0FBZ0J6QyxNQUFNLENBQUMsT0FBUCxHQUFpQiJ9
